import { render, staticRenderFns } from "./Messagecenter.vue?vue&type=template&id=40d796ce&scoped=true"
import script from "./Messagecenter.vue?vue&type=script&lang=js"
export * from "./Messagecenter.vue?vue&type=script&lang=js"
import style0 from "./Messagecenter.vue?vue&type=style&index=0&id=40d796ce&prod&scoped=true&lang=css"
import style1 from "./Messagecenter.vue?vue&type=style&index=1&id=40d796ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d796ce",
  null
  
)

export default component.exports